var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 396,
    viewBox: "0 0 396 396",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 198,
    r: 75.5378,
    stroke: "#55B4F1",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 198,
    r: 95.5042,
    stroke: "#55B4F1",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 198,
    r: 118.798,
    stroke: "#55B4F1",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 198,
    r: 145.42,
    stroke: "#55B4F1",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 198,
    r: 170.378,
    stroke: "#55B4F1",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 198,
    r: 197,
    stroke: "#55B4F1",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderShape);
export default __webpack_public_path__ + "static/media/border-shape.d3b7cf85cfc8f425435b0bf92cdf732f.svg";
export { ForwardRef as ReactComponent };